import { render, staticRenderFns } from "./CopySelectedTrade.vue?vue&type=template&id=7a63ec7e&scoped=true&"
import script from "./CopySelectedTrade.vue?vue&type=script&lang=js&"
export * from "./CopySelectedTrade.vue?vue&type=script&lang=js&"
import style0 from "./CopySelectedTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CopySelectedTrade.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./CopySelectedTrade.vue?vue&type=style&index=2&id=7a63ec7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a63ec7e",
  null
  
)

export default component.exports